import React from "react";

interface SidebarHeaderIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  title?: string;
}

const SidebarHeaderIcon: React.FC<SidebarHeaderIconProps> = ({
  size = 32,
  color = "black",
  title,
  className,
  ...props
}) => {
  const ariaProps = title
    ? { role: "img" as const, "aria-label": title }
    : { "aria-hidden": true };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...ariaProps}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M16.8889 8.88889V23.1111L24 16L16.8889 8.88889ZM3.55556 32C2.57778 32 1.74074 31.6519 1.04444 30.9556C0.348148 30.2593 0 29.4222 0 28.4444V3.55556C0 2.57778 0.348148 1.74074 1.04444 1.04444C1.74074 0.348148 2.57778 0 3.55556 0H28.4444C29.4222 0 30.2593 0.348148 30.9556 1.04444C31.6519 1.74074 32 2.57778 32 3.55556V28.4444C32 29.4222 31.6519 30.2593 30.9556 30.9556C30.2593 31.6519 29.4222 32 28.4444 32H3.55556ZM8.88889 28.4444V3.55556H3.55556V28.4444H8.88889ZM12.4444 28.4444H28.4444V3.55556H12.4444V28.4444Z"
        fill={color}
      />
    </svg>
  );
};

export default SidebarHeaderIcon;
